import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PopupDelete } from '@components/molecules/PopupDelete';

interface DeleteProductModalProps {
    productId: string | null;
    show: boolean;
    onClose: () => void;
}

export const DeleteProductModal: FC<DeleteProductModalProps> = ({ productId, show, onClose }) => {
    const { t } = useTranslation();

    const translations = {
        title: t('delete-product-modal-component.title'),
        description: t('delete-product-modal-component.description'),
        warning: t('delete-product-modal-component.warning'),
    };

    const deleteProduct: () => void = () => {
        /* #TODO */
        alert(`delete productId: ${productId}`);
        onClose();
    };

    return (
        <PopupDelete
            question={translations.title}
            confirmation={translations.description}
            warning={translations.warning}
            onClickConfirm={() => deleteProduct()}
            show={show}
            onHide={() => onClose()}
        />
    );
};
